export enum AddNewAccountComponentLocators {
	closeButton = 'closeButton',
	cancelButton = 'cancelButton',
	saveButton = 'saveButton',
	nameField = 'nameField',
	typeField = 'typeField',
}
